import { createFileRoute } from "@tanstack/react-router";
import { RoofingServicePage } from "@/components/RoofingServicePage";
import { solarRepairPages } from "@/data/solarRepairContent";

export const Route = createFileRoute("/services/solar-monitoring-repair")({
  head: () => ({
    meta: [
      { title: "Solar Monitoring Repair in Southern California - McKay Roofing & Solar" },
      { name: "description", content: "Fixing solar monitoring outages and offline systems across Southern California." },
      { property: "og:title", content: "Solar Monitoring Repair in Southern California - McKay Roofing & Solar" },
      { property: "og:description", content: "Fixing solar monitoring outages and offline systems across Southern California." },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/services/solar-monitoring-repair" }],
  }),
  component: () => <RoofingServicePage {...solarRepairPages["solar-monitoring-repair"]} />,
});
